import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const CellRender = (data, { isExpanded = false, isFirstRow = true } = {}) => {
  const sellerBrandId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId: data.id,
      property: 'sellerBrandId',
    }),
  );
  const sellerBrandName = useSelector((state) => Global.selectSellerSellerBrandById(state, { sellerBrandId }))?.companyName || '';
  if (isExpanded && !isFirstRow) {
    return null;
  }
  return sellerBrandName;
};

export const BrandName = {
  getMessageDescriptor: () => messages.brand,
  id: 'company-name',
  render: CellRender,
};
